import { tag } from 'ducks/entities/schema'

export const tagGraphQlResponseSchema = {
  tags: { nodes: [tag] },
}

export const tagGraphQlCreateResponseSchema = {
  tagCreate: { tag },
}
